import * as func from '../helpers/functions';
import $ from 'jquery';

/**
 *
 **/
class Nav {
    static targetAttrName = 'data-nav';

    #element //本体
    #myAttrName //属性名
    #button

    /**
     *
     **/
    constructor(element, targetAttrName = null) {
        let obj = this;

        obj.element = element;
        obj.myAttrName = targetAttrName ? targetAttrName : obj.constructor.targetAttrName;

        obj.button = document.querySelector('[' + obj.getMyAttrName('-button') + ']');
        if (!obj.button) {
            return;
        }

        $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
            // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
            obj.resize();
        });

        obj.button.addEventListener('click', function(e) {
            e.cancelBubble = true;
            if (obj.isOpen()) {
                obj.close();
            } else {
                obj.open();
            }
        });

        document.body.addEventListener('click', function() {
            obj.close();
        });

        var links = obj.element.querySelectorAll('a');
        Array.prototype.forEach.call(links, function(el, i) {
            el.addEventListener('click', function() {
                obj.close();
            })
        });
    }

    /**
     *
     **/
    resize() {
        let obj = this;
        if (Foundation.MediaQuery.atLeast('large')) {
            obj.close()
            return;
        }
    }

    /**
     *
     **/
    isOpen() {
        let obj = this;
        return func.hasClass(obj.element, 'expanded');
    }

    /**
     *
     **/
    open() {
        let obj = this;
        func.addClass(obj.element, 'expanded');
        func.addClass(obj.button, 'active');
    }

    /**
     *
     **/
    close() {
        let obj = this;
        func.removeClass(obj.element, 'expanded');
        func.removeClass(obj.button, 'active');
    }

    /**
     *
     **/
    getMyAttrName(additional = '') {
        return this.myAttrName + additional;
    }

    /**
     *
     **/
    static setup() {
        let attrName, element;

        attrName = Nav.targetAttrName;
        element = document.querySelector('[' + attrName + ']');
        if (element) {
            new Nav(element);
        }
    }
}

export default Nav;